<div
  class="crowdctrl-form-select-field-wrap"
  [class.crowdctrl-form-select-field-wrap--invalid]="invalid"
>
  @if (formControl) {
    <ion-select
      class="select-fill-outline"
      [formControl]="formControl"
      [label]="effectiveLabel"
      [placeholder]="effectivePlaceholder"
      [mode]="mode"
      [fill]="fill"
      [interface]="interface"
      [interfaceOptions]="interfaceOptions || {}"
      [attr.required]="effectiveRequired"
      [multiple]="multiple"
      [compareWith]="compareWith"
      [cancelText]="cancelText"
      [okText]="okText"
      [selectedText]="selectedText"
      (ionChange)="ionChange.emit($event)"
      (ionBlur)="ionBlur.emit($event)"
      (ionFocus)="ionFocus.emit($event)"
    >
      @for (opt of options; track opt.value) {
        <ion-select-option [value]="opt.value">{{ opt.label }}</ion-select-option>
      }
    </ion-select>
  } @else {
    <ion-select
      class="select-fill-outline"
      [label]="effectiveLabel"
      [placeholder]="effectivePlaceholder"
      [mode]="mode"
      [fill]="fill"
      [interface]="interface"
      [interfaceOptions]="interfaceOptions || {}"
      [attr.required]="effectiveRequired"
      [disabled]="disabled"
      [multiple]="multiple"
      [compareWith]="compareWith"
      [cancelText]="cancelText"
      [okText]="okText"
      [selectedText]="selectedText"
      (ionChange)="ionChange.emit($event)"
      (ionBlur)="ionBlur.emit($event)"
      (ionFocus)="ionFocus.emit($event)"
    >
      @for (opt of options; track opt.value) {
        <ion-select-option [value]="opt.value">{{ opt.label }}</ion-select-option>
      }
    </ion-select>
  }
  @if (hint) {
    <p class="crowdctrl-form-control-hint">{{ hint }}</p>
  }
</div>
